import { render } from "./index.vue?vue&type=template&id=6f5b3473&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6f5b3473&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5b3473"]])

export default __exports__